const SquareGroupIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 25.0461 0 17.5692 3.21539 12C5.32183 8.35154 8.35154 5.32183 12 3.21539C17.5692 0 25.0461 0 40 0C54.9539 0 62.4308 0 68 3.21539C71.6485 5.32183 74.6782 8.35154 76.7846 12C80 17.5692 80 25.0461 80 40C80 54.9539 80 62.4308 76.7846 68C74.6782 71.6485 71.6485 74.6782 68 76.7846C62.4308 80 54.9539 80 40 80C25.0461 80 17.5692 80 12 76.7846C8.35154 74.6782 5.32183 71.6485 3.21539 68C0 62.4308 0 54.9539 0 40Z"
        fill="#0E386D"
      />
      <path
        d="M34.6249 37.6468C33.2905 36.3197 32.4644 34.4819 32.4644 32.4513C32.4644 30.4206 33.2905 28.5828 34.6249 27.2558C33.8566 26.8785 32.9924 26.6667 32.0787 26.6667C28.884 26.6667 26.2942 29.2565 26.2942 32.4513C26.2942 35.646 28.884 38.2358 32.0787 38.2358C32.9924 38.2358 33.8566 38.024 34.6249 37.6468Z"
        fill="white"
      />
      <path
        d="M34.0069 32.4513C34.0069 29.2565 36.5968 26.6667 39.7915 26.6667C42.9862 26.6667 45.5761 29.2565 45.5761 32.4513C45.5761 35.646 42.9862 38.2358 39.7915 38.2358C36.5968 38.2358 34.0069 35.646 34.0069 32.4513Z"
        fill="white"
      />
      <path
        d="M44.9581 27.2558C46.2925 28.5828 47.1186 30.4206 47.1186 32.4513C47.1186 34.4819 46.2925 36.3197 44.9581 37.6468C45.7264 38.024 46.5906 38.2358 47.5043 38.2358C50.699 38.2358 53.2888 35.646 53.2888 32.4513C53.2888 29.2565 50.699 26.6667 47.5043 26.6667C46.5906 26.6667 45.7264 26.8785 44.9581 27.2558Z"
        fill="white"
      />
      <path
        d="M29.3793 46.3342C29.3793 43.1395 31.9691 40.5497 35.1638 40.5497H44.4192C47.6139 40.5497 50.2037 43.1395 50.2037 46.3342C50.2037 49.529 47.6139 52.1188 44.4192 52.1188H35.1638C31.9691 52.1188 29.3793 49.529 29.3793 46.3342Z"
        fill="white"
      />
      <path
        d="M21.6665 44.7917C21.6665 41.597 24.2563 39.0071 27.4511 39.0071H35.1638C31.1172 39.0071 27.8367 42.2876 27.8367 46.3342C27.8367 47.9152 28.3374 49.3791 29.1888 50.5763H27.4511C24.2563 50.5763 21.6665 47.9864 21.6665 44.7917Z"
        fill="white"
      />
      <path
        d="M51.7463 46.3342C51.7463 47.9152 51.2456 49.3791 50.3942 50.5763H52.1319C55.3267 50.5763 57.9165 47.9864 57.9165 44.7917C57.9165 41.597 55.3267 39.0071 52.1319 39.0071H44.4192C48.4658 39.0071 51.7463 42.2876 51.7463 46.3342Z"
        fill="white"
      />
    </svg>
  )
}

export default SquareGroupIcon
